/** Depth tint LUT: neutral desert sand at grade, darkening warm-brown descent. */
const SURFACE = { r: 0xe8, g: 0xd5, b: 0xa8 };
const DEEP = { r: 0x6e, g: 0x52, b: 0x38 };

function mix(a: number, b: number, t: number): number {
  return Math.round(a + (b - a) * t);
}

export const DEPTH_TINTS: readonly number[] = Array.from({ length: 8 }, (_, level) => {
  const t = Math.min(1, level / 6);
  return (mix(SURFACE.r, DEEP.r, t) << 16) | (mix(SURFACE.g, DEEP.g, t) << 8) | mix(SURFACE.b, DEEP.b, t);
});

/** Cliff faces darker than floors; SE faces darker than SW (fake sun from the west). */
export const FACE_TINT_SW: readonly number[] = Array.from({ length: 8 }, (_, level) => {
  const t = Math.min(1, level / 6);
  return (mix(0xc9, 0x54, t) << 16) | (mix(0xac, 0x3d, t) << 8) | mix(0x7e, 0x2a, t);
});

export const FACE_TINT_SE: readonly number[] = Array.from({ length: 8 }, (_, level) => {
  const t = Math.min(1, level / 6);
  return (mix(0xb2, 0x48, t) << 16) | (mix(0x94, 0x33, t) << 8) | mix(0x6b, 0x23, t);
});

export const ROAD_TINT = 0xb0a488;
export const DESIGNATION_TINT = 0xe8922a;
export const GHOST_VALID = 0x5fd068;
export const GHOST_INVALID = 0xe05252;
